<div class="container container-md">
    <div class="row mb-3">
        <div class="col-lg-8">
            <div class="h1 text-bold">FAQs</div>
            <p class="text-muted">Frequently asked questions.</p>
        </div>
        <div class="col-lg-4">
            <div class="card">
                <div class="card-body text-center">
                    <p class="mb-3">Please contact us if the question you have isn't listed here</p>
                    <a href="https://www.designautomator.com/contact" target="_blank"><button class="btn btn-info" type="button">Contact support</button></a>
                </div>
            </div>
        </div>
    </div>
    <div *ngFor="let section of sections">
        <h4 class="my-3 py-3 text-dark">{{section.title}}</h4>
        <accordion [closeOthers]="oneAtATime">
            <accordion-group panelClass="b0 mb-2" *ngFor="let question of section.questions">
                <div accordion-heading>
                    <small>
                        <em class="fa fa-plus text-primary mr-2"></em>
                    </small>
                    <span>{{question.title}}</span>
                </div>
                <p>
                    {{question.answer}}
                </p>
            </accordion-group>
        </accordion>
    </div>
</div>
